export var LIST_SIZES = {
  LARGE: 'large',
  STANDARD: 'standard'
};
export var LIST_ITEM_DIVIDER_TYPES = {
  FULL: 'full',
  INSET: 'inset'
};